export enum AutoComplete {
  PhoneNumber = 'tel',
  Email = 'email',
  FirstName = 'given-name',
  MiddleName = 'additional-name',
  LastName = 'family-name',
  Suburb = 'address-level2',
  PostCode = 'postal-code'
}
